export default __webpack_public_path__ + "b7cb90e83d79742ebd14171af8193a66.png";